import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import Loading from "../../PrivacyPolicy/Loading";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa"; // Import arrow icons
import { Link } from "react-router-dom";
import Image from "../../ui/Image";
import { useLanguage } from "../../../store/language-context";
import { useTranslation } from "react-i18next";

const Certificate = () => {
  const [dataItems, setDataItems] = useState([]);
  const { URL } = useLanguage();
  const { t } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${URL}/home-pages?title_section=quality_certifications`
        );
        if (response.data.status === 200) {
          const fetchedData = Array.isArray(response.data.data.data)
            ? response.data.data.data
            : [response.data.data.data]; // Ensure it's an array
          setDataItems(fetchedData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [URL]);

  if (dataItems.length === 0) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  // Slick Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 3000,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 776,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="container">
      <section className="quality-container ">
        <h2 className="section-title ">
          {t('about.certificates')}
        </h2>

        <Slider {...settings} className="quality-slider">
          {dataItems.map((item, index) =>
            item ? (
              <div key={index} className="quality-slide ">

                <div className="quality-certificate !w-full">
                  <h6>{item.title}</h6>
                  {item.image ? (
                    <Link to={item.image} className="!w-full h-full relative flex" target="_blank">
                      <Image src={item.image} alt={item.title} className="h-full !w-full" />
                    </Link>
                  ) : (
                    <div>
                      No Image Available
                    </div>
                  )}

                </div>
              </div>
            ) : null
          )}
        </Slider>
      </section>
    </div>
  );
};

const NextArrow = ({ onClick }) => {
  return (
    <div
      className="slick-arrow slick-next"
      onClick={onClick}
    >
      <FaChevronRight size={20} />
    </div>
  );
};

const PrevArrow = ({ onClick }) => {
  return (
    <div
      className="slick-arrow slick-prev"
      onClick={onClick}
    >
      <FaChevronLeft size={20} />
    </div>
  );
};


export default React.memo(Certificate);